// extracted by mini-css-extract-plugin
export default {"cleDemo":"cleDemo-ltnYx"};